import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/main.css';
//containers import TopBar from './topBar';
import BottomBar from './bottomBar';
import VideoPlayer from './videoPlayer';
import GameTabs from '../../sharedComponents/containers/gameTabs';
import ModalPopup from '../../sharedComponents/containers/modalPopup';
import BetHistory from '../../sharedComponents/containers/betHistory';
import HelpPages from '../../sharedComponents/containers/helpPages';
import Settings from '../../sharedComponents/containers/settings';
import GameCard from './gameCard';
import TotalBets from '../components/totalBets';
// constants
import {NOTIFICATION_MODAL_TYPE} from '../../../../constants/identifiers';
import {ADVERTS_URL} from '../../../../constants/endpoints';

const mapStateToProps = (state, ownProps) => {
    return {
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
        isBetHistoryOpen: state.vpp.isBetHistoryOpen,
        isHelpPagesOpen: state.vpp.isHelpPagesOpen,
        isSettingsOpen: state.vpp.isSettingsOpen,
        isVideoVisible: state.vpp.isVideoVisible
    };
};

class Main extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isModalOpen: storeData.vpp.isModalOpen,
            openModalType: storeData.vpp.openModalType,
            isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
            isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
            isSettingsOpen: storeData.vpp.isSettingsOpen,
            isVideoVisible: storeData.vpp.isVideoVisible
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                isModalOpen: storeData.vpp.isModalOpen,
                openModalType: storeData.vpp.openModalType,
                isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
                isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
                isSettingsOpen: storeData.vpp.isSettingsOpen,
                isVideoVisible: storeData.vpp.isVideoVisible
            });
        }
    }

    render() {
        let modal;
        if (this.state.isModalOpen) {
            switch (this.state.openModalType) {
                case NOTIFICATION_MODAL_TYPE:
                    modal = (<ModalPopup id='notificationPopup' store={this.props.store}
                                         modalType={NOTIFICATION_MODAL_TYPE}/>);
                    break;
                default:
                    break;
            }
        }

        let betHistory;
        if (this.state.isBetHistoryOpen) {
            betHistory = (<BetHistory store={this.props.store}/>);
        }

        let helpPages;
        if (this.state.isHelpPagesOpen) {
            helpPages = (<HelpPages store={this.props.store}/>);
        }

        let settings;
        if (this.state.isSettingsOpen) {
            settings = (<Settings store={this.props.store}/>);
        }

        let leftContainer;
        if (this.state.isVideoVisible) {
            leftContainer = (<div className={style.leftContainer}>
                {/* <div className={style.leftTopBar}>
            <TopBar store={this.props.store}/>
          </div> */
                }
                <div className={style.leftBottomContainer}>
                    <div id={'videoPlayerContainer'} className={style.videoPlayerContainer}>
                        <VideoPlayer store={this.props.store}/>
                    </div>
                    <div className={style.advertiseContainer}>
                        <div id='adverts_container' className={style.advertise}>
                            <iframe className={style.advertIframe} title='advertise' type='text/html' frameBorder='0'
                                    src={ADVERTS_URL}></iframe>
                        </div>
                    </div>
                </div>
            </div>);
        }

        return (<div className={style.mainContainer} id={'Simplified-UI-Desktop-Container'}>
            {leftContainer}
            <div className={`${this.state.isVideoVisible
                ? style.rightContainer
                : style.centerContainer}`}>
                <div className={style.rightTopBarContainer}>
                    <GameTabs store={this.props.store}/>
                </div>
                <div className={style.rightContentContainer}>
                    <GameCard store={this.props.store}/>
                </div>
                <div className={style.rightBottomBarContainer}>
                    <BottomBar store={this.props.store}/>
                </div>
                <TotalBets store={this.props.store}/>
            </div>
            {modal}
            {betHistory}
            {helpPages}
            {settings}
        </div>);
    }
}

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/desktop/containers/main.js